<template>
  <Teleport to="body">
    <div
      class="tw-absolute tw-right-10 tw-top-10 tw-z-[55] tw-flex tw-flex-col-reverse tw-gap-2"
    >
      <cl-toast
        v-for="toast in toasts"
        :id="toast.id"
        :key="toast.id"
        :title="toast.title"
        :message="toast.message"
        :variant="toast.variant"
        :test-id="toast.testId"
        @on-close="closeToast(toast.id)"
      />
    </div>
  </Teleport>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { useToastStore } from "./toast.store";

const store = useToastStore();
const toasts = computed(() => store.toasts);

const closeToast = (id: string) => store.closeToast(id);
</script>
